module.exports = __webpack_public_path__ + "img/logo.016fecf7.svg";